import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { waitForSession } from './app/useSession'

async function initializeApp() {
  const root = createRoot(document.getElementById('root')!)

  root.render(
    <StrictMode>
      <App />
    </StrictMode>
  )
}

initializeApp()